export const privacyLink = "Iba";
export default {privacyLink};